import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useTranslation } from "react-i18next";
import CreateIncidentForm from "./CreateIncidentForm";
import { useLocation } from "react-router-dom";

const IncidentForm = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  let edit = state?.edit;
 // let view = state?.view;

  console.log(state, "edit")

  useEffect(() => {
    GridStack.init();
  }, []);
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: (
        <DMSHeader
          title={
            // view ? t('View Contact Detaiils') :
            edit ? t("Edit Incident Details") : t("Create Incident")
          }
          showIconsForback={edit}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 13,
      id: 1,
      component: <CreateIncidentForm />,
    },
  ];
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default IncidentForm;
